import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Allblogs from '../components/Blogs/Blogs'

const Blogpage = () => {
  return (
    <div>
    <Navbar/>
    <Allblogs/>


    <Footer/>
    </div>
  )
}

export default Blogpage